import PolicyLayout from "@/components/PolicyLayout";

function PolicyCard({ title, children }) {
  return (
    <div className="bg-card border border-border/40 rounded-sm p-6 sm:p-8 mb-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none">
      <h3 className="font-heading text-lg sm:text-xl tracking-tight font-medium mb-3">{title}</h3>
      <div className="text-base leading-relaxed text-muted-foreground">{children}</div>
    </div>
  );
}

export default function RefundPolicyPage() {
  return (
    <PolicyLayout title="Refund, Cancellation & No-Match Policy" subtitle="Transparency first">
      <p className="text-base leading-relaxed text-muted-foreground mb-8">
        <em className="text-sm">Last updated: {new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</em>
      </p>

      <p className="text-base leading-relaxed text-muted-foreground mb-10">
        We believe in being upfront about what you're paying for and what to expect. Below is our complete
        refund, cancellation, and no-match policy.
      </p>

      <PolicyCard title="Men's Ticket (₹1,399)">
        <p className="mb-2">
          The ticket price is <strong className="text-foreground">non-refundable once booked</strong>. Your ticket gives you
          access to the full curated event experience: the venue, professional hosting, icebreaker games, structured
          mini-dates, and the mutual-matching system.
        </p>
        <p>
          A ticket is for event participation — <strong className="text-foreground">not guaranteed dating success</strong>.
        </p>
      </PolicyCard>

      <PolicyCard title="Women's Registration (Free / Waitlist)">
        <p>
          Women's registration is free and waitlist-based. Registration is subject to organizer approval and event
          capacity. Being on the waitlist does not guarantee a seat at every event.
        </p>
      </PolicyCard>

      <PolicyCard title="No-Match Credit">
        <p className="mb-2">
          If you attend an event and receive <strong className="text-foreground">zero mutual matches</strong>, Cita Rush may provide a
          one-time discount code or credit toward a future event, at our discretion.
        </p>
        <ul className="space-y-1.5 mt-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            No cash refund is provided for zero-match scenarios.
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            Credits, if issued, are valid for 90 days from the date of issue.
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            No refund for simply not liking any attendees or not being selected by anyone.
          </li>
        </ul>
      </PolicyCard>

      <PolicyCard title="Event Cancellation by Cita Rush">
        <p className="mb-2">
          If Cita Rush cancels or significantly reschedules an event, participants may receive:
        </p>
        <ul className="space-y-1.5 mt-3">
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            Transfer to a rescheduled or alternative event.
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            Credit toward a future event.
          </li>
          <li className="flex items-start gap-3">
            <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--accent))] mt-2 flex-shrink-0" />
            Refund option, at the sole discretion of the admin team.
          </li>
        </ul>
      </PolicyCard>

      <PolicyCard title="No-Show Policy">
        <p>
          Guests who do not show up for a confirmed event are <strong className="text-foreground">not entitled to a refund</strong>.
          Late arrivals may miss rounds and are still not eligible for a refund.
        </p>
      </PolicyCard>

      <PolicyCard title="Credit Validity">
        <p>
          Any credits or discount codes issued by Cita Rush are valid for <strong className="text-foreground">90 days</strong> from the date of
          issue, unless otherwise stated. Credits are non-transferable and cannot be exchanged for cash.
        </p>
      </PolicyCard>

      <div className="mt-10 pt-8 border-t border-border/50">
        <p className="text-sm text-muted-foreground">
          For refund or cancellation questions, contact us at{" "}
          <span className="text-foreground font-medium">support@citarush.com</span>.
        </p>
      </div>
    </PolicyLayout>
  );
}
